export enum GovernanceConfigurationType {
  ExistingToken = "existing-token",
  RoleBased = "role-based",
  NFT = "nft",
  ProjectFundraise = "project-fundraise",
}

export enum ApplicationStatus {
  Opened = "opened",
  Closed = "closed",
}

export enum CreateClubWizardSteps {
  BasicInfo = "basicInfo",
  GovernanceConfiguration = "governanceConfiguration",
  NFTConfiguration = "nftConfiguration",
  Roles = "roles",
  Members = "members",
  Verification = "verification",
  FundraisingConfiguration = "fundingConfiguration",
  FinancialConfiguration = "financialConfiguration",
  Preview = "preview",
}
